import styled from 'styled-components';

import { Button } from 'components/Button';
import { IconButton } from 'components/Button/IconButton';

export const StyledButton = styled(Button)`
  padding: 4px 16px;
`;

export const StyledIconButton = styled(IconButton)`
  font-size: 10.5px;
  line-height: 15px;
  padding: 8px 13px;
`;
